import React, { useEffect, useState } from 'react';
import { LaunchDarklyProvider } from '../launch-darkly-provider/LaunchDarklyProvider';
import { fetchLaunchDarklyClientConfig } from '../../../shared/fetch-data/fetch-launch-darkly-config';
import { useFeatureServices } from '../../hooks/use-feature-services';

interface LaunchDarklyWrapperProps {
  baseUrl?: string;
  children: React.ReactNode;
}

export const LaunchDarklyWrapper: React.FC<LaunchDarklyWrapperProps> = ({
  baseUrl,
  children,
}) => {
  const [clientId, setClientId] = useState<string>('');
  const { 'locale-service': localeService } = useFeatureServices();
  const { countryCode = '' } = localeService;

  useEffect(() => {
    const fetchLDKey = async () => {
      const key = await fetchLaunchDarklyClientConfig(baseUrl);
      setClientId(key);
    };
    fetchLDKey();
  }, [baseUrl]);

  return (
    <LaunchDarklyProvider clientId={clientId} countryCode={countryCode}>{children}</LaunchDarklyProvider>
  );
};
